<template>
    <div id="registered">
        <div class="container m_t">
            <div class="center_title">
                <Title en="Membership Application" chtFirst="申請" chtSecond="入會" :center="true"></Title>
            </div>
            <section class="content">
                <div class="step1" v-if="nowStep == 1">
                    <div class="global_title">入會須知</div>
                    <div class="box">
                        <div class="title">本會會員申請資格如下:</div>
                        <p class="paragraph">一、個人會員:凡贊同本會宗旨、年滿二十歲者，並符合以下兩類資格之一者。</p>
                        <ul>
                            <li>
                                <p>第一類:視網膜臨床專科醫師，請同時具備下列資格:</p>
                                <p>1.凡在政府認可之國內外醫學院校畢業，並取得行政院衛生署核發之眼科專科醫師證書資格者。</p>
                                <p>2.受過一年以上視網膜專科訓練，或經本會遴選委員會推薦者。</p>
                            </li>
                            <li>
                                <p>第二類:醫學相關學術領域研究有成者，且具備下列資格之一:</p>
                                <p>1.從事視網膜醫學會領域之研究或教學者。</p>
                                <p>2.曾就讀於國內外大學，其學術論文與視網膜研究相關者。</p>
                            </li>
                        </ul>
                        <p
                            class="paragraph"
                        >※上述兩類之申請者，申請時應填具入會申請書，由本會會員二人以上之介紹，經理事會審查通過，並繳納會費方可取得會員資格（其中第二類會員尚須提出已出版之學術論文）。</p>
                        <p class="paragraph">※入會費:會員新台幣伍仟元，準會員新台幣壹仟元，於入會時繳納。</p>
                        <p class="paragraph global_mb20">※常年會費:會員新台幣壹仟元。</p>
                        <div class="title">本會會員申請入會辦法及流程說明:</div>
                    </div>
                    <div class="global_title">會員申請入會辦法及流程</div>
                    <div class="box">
                        <div class="step_box" v-for="(step,index) in Steps" :key="index">
                            <div class="subtitle">
                                <div>Step.0{{index + 1}}</div>
                                <div>{{step.Title}}</div>
                                <div v-if="step.Title2">{{step.Title2}}</div>
                            </div>
                            <div class="info">
                                <div>{{step.Info}}</div>
                                <div v-if="step.Remark" v-html="step.Remark" class="remark"></div>
                            </div>
                        </div>
                    </div>
                    <div class="btn_box">
                        <div class="Orange_btn islogin" @click="nextStep">
                            <a href="javascript:;">入會申請</a>
                        </div>
                    </div>
                </div>
                <div class="step2 animated fadeIn" v-if="nowStep == 2">
                    <div class="global_title">帳號註冊</div>
                    <div class="form">
                        <div class="input_span">
                            <span>帳號(Email)</span>
                            <input
                                type="text"
                                placeholder="請填寫完整的E-mail"
                                v-model="RegisterParams.Email"
                            />
                        </div>
                        <div class="input_span">
                            <span>密碼</span>
                            <input
                                type="password"
                                placeholder="6-12碼數字英混合"
                                minlength="6"
                                maxlength="12"
                                v-model="RegisterParams.Password"
                            />
                        </div>
                        <div class="input_span">
                            <span>再次確認密碼</span>
                            <input type="password" placeholder="確認密碼" v-model="CheckPassword" />
                        </div>
                        <div class="input_span">
                            <span>請輸入驗證碼</span>
                            <div class="id">
                                <input type="text" placeholder="請輸入下方驗證碼" v-model="CheckId" />
                                <Sidentify :identifyCode="identifyCode"></Sidentify>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    x="0px"
                                    y="0px"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 172 172"
                                    style=" fill:#000000;"
                                    @click="refreshCode"
                                >
                                    <g
                                        fill="none"
                                        fill-rule="none"
                                        stroke="none"
                                        stroke-width="1"
                                        stroke-linecap="butt"
                                        stroke-linejoin="miter"
                                        stroke-miterlimit="10"
                                        stroke-dasharray
                                        stroke-dashoffset="0"
                                        font-family="none"
                                        font-weight="none"
                                        font-size="none"
                                        text-anchor="none"
                                        style="mix-blend-mode: normal"
                                    >
                                        <path
                                            d="M0,172v-172h172v172z"
                                            fill="none"
                                            fill-rule="nonzero"
                                        />
                                        <g fill="#333333" fill-rule="evenodd">
                                            <g id="surface1">
                                                <path
                                                    d="M109.82357,31.85808c-13.10156,-5.76693 -27.88281,-6.66276 -41.62826,-2.32357c-26.11914,8.23047 -43.05599,33.00586 -41.29232,60.27278l-17.83268,1.17578c-2.29557,-35.5254 19.79232,-67.7754 53.75,-78.4974c19.87631,-6.27083 41.43229,-4.08724 59.71289,5.79492l17.10482,-18.2806l4.56315,50.69857l-53.69401,1.79167zM109.15169,159.51433c-7.5306,2.35156 -15.34115,3.55533 -23.0957,3.55533c-12.65365,0 -25.22331,-3.27539 -36.5612,-9.37825l-17.13281,18.30859l-4.53515,-50.69857l53.66601,-1.79167l-19.28841,20.63217c13.04557,5.73893 27.82682,6.66276 41.57226,2.32356c26.11914,-8.25846 43.08399,-33.06185 41.32031,-60.27278l17.80469,-1.17578c2.35156,35.4694 -19.76433,67.7474 -53.75,78.4974z"
                                                />
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <!-- <div class="input_span">
                            <span>請輸入驗證碼</span>
                            <input type="text" placeholder="請輸入驗證碼" v-model="CheckId" />
                        </div>
                        <div class="id">
                            <Sidentify :identifyCode="identifyCode"></Sidentify>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                width="24"
                                height="24"
                                viewBox="0 0 172 172"
                                style=" fill:#000000;"
                                @click="refreshCode"
                            >
                                <g
                                    fill="none"
                                    fill-rule="none"
                                    stroke="none"
                                    stroke-width="1"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray
                                    stroke-dashoffset="0"
                                    font-family="none"
                                    font-weight="none"
                                    font-size="none"
                                    text-anchor="none"
                                    style="mix-blend-mode: normal"
                                >
                                    <path d="M0,172v-172h172v172z" fill="none" fill-rule="nonzero" />
                                    <g fill="#333333" fill-rule="evenodd">
                                        <g id="surface1">
                                            <path
                                                d="M109.82357,31.85808c-13.10156,-5.76693 -27.88281,-6.66276 -41.62826,-2.32357c-26.11914,8.23047 -43.05599,33.00586 -41.29232,60.27278l-17.83268,1.17578c-2.29557,-35.5254 19.79232,-67.7754 53.75,-78.4974c19.87631,-6.27083 41.43229,-4.08724 59.71289,5.79492l17.10482,-18.2806l4.56315,50.69857l-53.69401,1.79167zM109.15169,159.51433c-7.5306,2.35156 -15.34115,3.55533 -23.0957,3.55533c-12.65365,0 -25.22331,-3.27539 -36.5612,-9.37825l-17.13281,18.30859l-4.53515,-50.69857l53.66601,-1.79167l-19.28841,20.63217c13.04557,5.73893 27.82682,6.66276 41.57226,2.32356c26.11914,-8.25846 43.08399,-33.06185 41.32031,-60.27278l17.80469,-1.17578c2.35156,35.4694 -19.76433,67.7474 -53.75,78.4974z"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>-->
                        <div class="btn_box">
                            <div class="item">
                                <div class="White_btn islogin">
                                    <a href="javascript:;">重新填寫</a>
                                </div>
                            </div>
                            <div class="item">
                                <div class="Orange_btn islogin">
                                    <a href="javascript:;" @click="register">確定送出</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <graybtn />
        </div>
        <Popup v-if="popupshow" @closePopup="closeRegister">
            <p>恭喜您!已完成"帳號註冊"</p>
            <p>您的帳號啟動信已經寄至</p>
            <p>
                <span>{{RegisterParams.Email}}</span>
            </p>
            <p>請至您的電子信箱收取信件，並按照信件只是完成帳號驗證，</p>
            <p>
                如果經過一段時間，您仍然沒有收到
                <span>中華民國視網膜學會</span>的帳號驗證信件，
                <br />郵件有可能被分類到垃圾信件。請查看您的垃圾郵件信件箱
            </p>
            <p>
                ※請設置
                <span>twrs.tw@gmail.com</span>郵件為非垃圾郵件，
                <br />並加入為聯絡人，避免郵件丟失。
            </p>
            <div class="btn_box">
                <div class="Orange_btn islogin" @click="goMember">
                    <a href="javascript:;">確認</a>
                </div>
            </div>
        </Popup>
        <loading v-if="isLoading"></loading>
    </div>
</template>

<script>
import Sidentify from "@/components/identify";
import Popup from "@/components/popup";
import API from "@/service/member";
import Common from "@/common";
export default {
    name: "registered",
    components: {
        Sidentify,
        Popup
    },
    props: {},
    data() {
        return {
            Steps: [
                {
                    Title: `註冊帳號`,
                    Title2: ``,
                    Info: `點擊右上 "申請入會" ，填寫您欲註冊之E-mail帳號及密碼。`,
                    Remark: ``
                },
                {
                    Title: `接收驗證信`,
                    Title2: ``,
                    Info: `"Step.01"確認送出後，請接收註冊驗證信。`,
                    Remark: `※若未接收到，請再次點擊"寄送驗證信"，進行驗證。`
                },
                {
                    Title: `填寫入會申請書`,
                    Title2: ``,
                    Info: `"Step.02"完成後，請填寫入會申請書。`,
                    Remark: ``
                },
                {
                    Title: `上傳入會資料`,
                    Title2: ``,
                    Info: `"Step.03"完成後，請確認並列印入會單，並依照指示上傳所需之資料`,
                    Remark: `※上傳資料:"<span style='color:#f00;'>已有介紹人簽名</span>"之入會申請書、醫師證書及專科醫師證書、畢業證書。`
                },
                {
                    Title: `學會審核`,
                    Title2: ``,
                    Info: `"Step.04"完成後，請等候3-5個審核工作天。`,
                    Remark: `※你可隨時留意會員專區，或隨時留意學會通知信，若有問題您可至"會員專區"確認並處理。`
                },
                {
                    Title: `審核完成`,
                    Title2: `線上繳費`,
                    Info: `"Step.05"完成後，請您登入會員專區，完成線上繳費。`,
                    Remark: ``
                },
                {
                    Title: `繳費完成`,
                    Title2: `成為正式會員`,
                    Info: `"Step.06"完成後，請您可至會員專區，確認狀態及變更為"正式會員"。`,
                    Remark: `※會員狀態，會期時間將會顯示您的繳費資訊(含入會費用及當年會費。)`
                }
            ],
            nowStep: 1,
            //圖形驗證
            identifyCode: "",
            // identifyCodes: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ",
            identifyCodes: "23456789ABCDEFGHJKMNPQRSTUVWXYZ",
            isLoading: false,
            popupshow: false,
            RegisterParams: {
                Email: "",
                Password: ""
            },
            CheckPassword: "",
            CheckId: ""
        };
    },
    methods: {
        /*圖形驗證*/
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        refreshCode() {
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
            // console.log("當前驗證碼==", this.identifyCode);
        },
        makeCode(o, length) {
            for (let i = 0; i < length; i++) {
                this.identifyCode += o[this.randomNum(0, o.length)];
            }
        },
        nextStep() {
            const vm = this;
            if (vm.nowStep == 1) {
                vm.nowStep = 2;
                window.scrollTo(0, 0);
            }
        },
        reset() {
            const vm = this;
            vm.RegisterParams = {
                Email: "",
                Password: ""
            };
            vm.CheckPassword = "";
            vm.CheckId = "";
        },
        //註冊
        register() {
            const vm = this;
            if (vm.RegisterParams.Email == "") {
                vm.$swal({
                    type: "warning",
                    text: "帳號信箱為空",
                    confirmButtonText: "確定"
                });
                return false;
            }
            if (!Common.IsEmail(vm.RegisterParams.Email)) {
                vm.$swal({
                    type: "warning",
                    text: "帳號信箱格式錯誤。",
                    confirmButtonText: "確定"
                });
                return false;
            }
            if (vm.RegisterParams.Password == "") {
                vm.$swal({
                    type: "warning",
                    text: "密碼為空",
                    confirmButtonText: "確定"
                });
                return false;
            }
            if (vm.RegisterParams.Password != vm.CheckPassword) {
                vm.$swal({
                    type: "warning",
                    text: "密碼不一致 請再輸入一次!",
                    confirmButtonText: "確定"
                });
                vm.$set(vm.RegisterParams, "Password", "");
                vm.CheckPassword = "";
                return false;
            }
            if (vm.CheckId == "") {
                vm.$swal({
                    type: "warning",
                    text: "請輸入驗證碼!",
                    confirmButtonText: "確定"
                });
                vm.refreshCode();
                return false;
            }
            if (vm.CheckId !== vm.identifyCode) {
                vm.$swal({
                    type: "warning",
                    text: "驗證碼輸入錯誤，請重新輸入!",
                    confirmButtonText: "確定"
                });
                vm.refreshCode();
                return false;
            }
            vm.isLoading = true;
            API.getRegister(vm.RegisterParams).then(result => {
                // console.log(result);
                setTimeout(function() {
                    vm.isLoading = false;
                }, 500);
                if (result != undefined) {
                    if (result.Ok) {
                        // 註冊成功 打登入API
                        API.getLogin(vm.RegisterParams).then(result => {
                            vm.popupshow = true;
                            setTimeout(function() {
                                location.href = "/Member/Status";
                            }, 8000);
                        });
                    }
                } else {
                    vm.$swal({
                        type: "warning",
                        text: "帳號已存在!",
                        confirmButtonText: "確定"
                    });
                }
            });
        },
        goMember() {
            const vm = this;
            vm.popupshow = false;
            location.href = "/Member/Status";
        },
        closeRegister() {
            const vm = this;
            vm.popupshow = false;
            location.herf = "/Member";
        }
    },
    computed: {},
    created() {
        const vm = this;
        vm.refreshCode(); //初始化圖形驗證
    },
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#registered .content {
    border: 8px solid #eee;
    padding: 20px;
    color: #666;
}
#registered .content .step1 .box {
    padding: 0 20px;
    letter-spacing: 3px;
    line-height: 1.5;
    word-break: break-all;
}
#registered .content .step1 .box .title {
    font-size: 1.2rem;
    margin-bottom: 20px;
}
#registered .content .step1 .box ul {
    padding: 50px 0;
}
#registered .content .step1 .box ul li p:not(:first-child) {
    padding-left: 22px;
}
#registered .content .step1 .box .step_box {
    display: flex;
    align-items: stretch;
    flex-wrap: wrap;
}
#registered .content .step1 .box .step_box:not(:last-child):after {
    content: "↓";
    min-width: 190px;
    text-align: center;
    font-size: 36px;
    padding: 10px 0;
}
#registered .content .step1 .box .step_box .subtitle {
    background-color: #eee;
    padding: 15px 25px;
    color: #000;
    min-width: 190px;
    text-align: center;
}
#registered .content .step1 .box .step_box .info {
    padding: 15px;
    border: 1px solid #eee;
    width: calc(100% - 190px);
}
#registered .content .step1 .box .step_box .info .remark {
    font-size: 0.9rem;
    color: #aaa;
    padding: 8px 0;
}
#registered .content .step1 .btn_box {
    width: 165px;
    margin: auto;
    padding: 50px 0;
}
#registered .content .step2 .form .input_span {
    margin: auto;
}

@keyframes oxxo {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
#registered .content .step2 .btn_box {
    margin: auto;
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    /* width: 350px; */
    padding: 30px 0;
}
#registered .content .step2 .btn_box .item {
    width: 48%;
}
#registered .content .step3 .wrap {
    line-height: 1.5;
    letter-spacing: 3px;
}
#registered .content .step3 .wrap p {
    padding: 10px 0;
}
#registered .content .step3 .wrap p strong {
    font-weight: 600;
}
#registered .content .step3 .wrap p span {
    color: #ee8b59;
}
#registered .content .step3 .btn_box {
    width: 165px;
    padding: 30px 0;
}
#registered .content .step4 .box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
#registered .content .step4 .remark {
    text-align: center;
    line-height: 1.5;
    letter-spacing: 2px;
    margin-bottom: 20px;
}
#registered .content .step4 .address,
#registered .content .step4 .introduction,
#registered .content .step4 .id {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: calc(100% - 167px);
    /* justify-content: space-between; */
}
#registered .content .step4 .address select {
    width: 49%;
    margin-bottom: 10px;
}
#registered .content .step4 .address select + select {
    margin-left: 2%;
}
#registered .content .step4 .address input {
    width: 100%;
}
#registered .content .step4 .introduction input,
#registered .content .step4 .id input {
    width: 100%;
    margin-bottom: 10px;
}
#registered .content .step4 .introduction > div {
    color: #333;
    letter-spacing: 1px;
    line-height: 1.2;
}
#registered .content .step4 .final {
    line-height: 1.5;
    letter-spacing: 2px;
    padding: 30px 0;
}
#registered .content .step4 .final p:nth-child(1) {
    margin-bottom: 20px;
}
#registered .content .step4 .final p:last-child {
    margin-top: 20px;
}
#registered .content .step4 .btn_box {
    margin: auto;
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 30px 0;
}
#registered .content .step4 .btn_box .item {
    width: 48%;
}

.global_mb20 {
    margin-bottom: 20px;
}
#registered >>> #popup .btn_box {
    width: 165px;
    margin: 40px auto 20px;
}
@media screen and (max-width: 767px) {
    /* Step 01 */
    #registered .content {
        padding: 20px 10px;
    }
    #registered .content .step1 .box {
        padding: 0;
    }
    #registered .content .step1 .box .step_box .subtitle {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }
    #registered .content .step1 .box .step_box .subtitle div:nth-child(1) {
        width: 100%;
    }
    #registered .content .step1 .box .step_box .info {
        width: 100%;
        padding: 15px 5px;
        text-align: center;
    }
    #registered .content .step1 .box .step_box:not(:last-child):after {
        width: 100%;
    }
    /* Step02 */
    #registered .content .step2 .id {
        width: 100%;
        padding: 15px 0;
    }
    #registered .content .step2 .btn_box,
    #registered .content .step4 .btn_box {
        width: 100%;
    }
    #registered .content .step3 .btn_box {
        margin: auto;
    }
    #registered .content .step4 .address,
    #registered .content .step4 .introduction,
    #registered .content .step4 .id {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/registered.vue